// Single source of truth for the visible build stamp.
// Bump this whenever you want the user-facing "version" string in Settings to change.
export const APP_VERSION = "v1.0.1";
export const APP_BUILD = "2026-05-31";
